import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import axios from 'axios';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthData } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        console.log('Processing OAuth callback, hash:', hash);
        
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login', { replace: true });
          return;
        }

        console.log('Got session_id, sending to backend...');

        // Send session_id to our backend - backend handles Emergent API call
        const authResponse = await axios.post(`${API}/auth/google`, {
          session_id: sessionId
        });

        const { access_token, user } = authResponse.data;
        console.log('Backend auth successful, user:', user?.email);

        // Set auth data in context (this updates state and localStorage)
        setAuthData(access_token, user);

        // Clear the URL hash and redirect to dashboard
        window.history.replaceState(null, '', '/');
        
        // Small delay to ensure state is updated
        setTimeout(() => {
          navigate('/dashboard', { replace: true });
        }, 100);

      } catch (error) {
        console.error('OAuth callback error:', error);
        console.error('Error details:', error.response?.data || error.message);
        
        // Show more specific error message
        let errorMessage = 'Authentication failed. Please try again.';
        if (error.response?.data?.detail) {
          errorMessage = typeof error.response.data.detail === 'string' 
            ? error.response.data.detail 
            : JSON.stringify(error.response.data.detail);
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        // Store error in sessionStorage so login page can show it
        sessionStorage.setItem('oauth_error', errorMessage);
        
        navigate('/login', { 
          replace: true,
          state: { error: errorMessage }
        });
      }
    };

    processOAuthCallback();
  }, [navigate, setAuthData]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/30">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
